import React from "react";

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path d="M0 0v2.46h14V0H0zM.24 3.281l4.722 4.694L5.409 14l3.209-1.857.416-4.163L13.76 3.28H.24z"></path>
    </svg>
  );
}
